module.exports = __webpack_public_path__ + "img/footer-logo2.665b1612.png";